export enum ScannerActionType {
    CheckedIn = 1,
    CheckedOut = 2
}
